// Vendor Libs
import React from 'react';
import {useSelector} from 'react-redux';

// Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
import {AuthLoading, Unauthorized} from '@dishtech-react/core';

// Contexts
import {BrowserRouter, Route} from 'react-router-dom';
import {RouteContext} from '../../../contexts/route-context';

// Components
import OutOfFlash from '../../OutOfFlash.tsx';
import logo from '../../../assets/dish_logo_red.svg';

const outOfFlashRoute = (
  <BrowserRouter>
    <Route path="/" component={OutOfFlash} />
    <Route path="OutOfFlash/*" component={OutOfFlash} />
  </BrowserRouter>
);

const Main = () => {
  const authorized = useSelector(({auth: {user: {isAuthorized} = {}} = {}}) => isAuthorized);
  const isCredentialExpired = useSelector(
      ({auth: {user: {credentialsNonExpired} = {}} = {}}) => !credentialsNonExpired
  );

  return (
    <div className="main">
        <RouteContext.Provider value={useRouter()}>
            {isCredentialExpired ? (
                <AuthLoading img={logo} />
            ) : authorized !== false ? (
                <div className="main--content">{outOfFlashRoute}</div>
            ) : (
                <Unauthorized />
            )}
        </RouteContext.Provider>
    </div>
  )
};

export default Main;
